
























import { ComponentInternalInstance, computed, defineComponent, getCurrentInstance, toRefs } from '@vue/composition-api';
import { ChevronLeftIcon } from 'tdesign-icons-vue';

import GeneralHeader from '@/renderer/views/desktop/headbar/components/GeneralHeader/index.vue';
import PreviewHeader from '@/renderer/views/desktop/headbar/components/PreviewHeader.vue';
import MobileGeneralHeader from '@/renderer/views/desktop/headbar/components/MobileGeneralHeader/index.vue';
import MobilePreviewHeader from '@/renderer/views/desktop/headbar/components/MobilePreviewHeader.vue';
import InvitationHeader from '@/renderer/views/desktop/headbar/components/InvitationHeader.vue';
import AdminRouterHeader from '@/renderer/views/desktop/headbar/components/AdminRouterHeader.vue';

import { InviteTitleData } from '@/renderer/views/common/collect/index.vue';
import { OrgLogoInfo } from '@/renderer/scripts/libs/smh-sdk-class/typings';

import { adminRouterName } from '@/renderer/scripts/utils/tools';
import { PreviewHandler } from '../../preview/compositions/previewHandler';

export default defineComponent({
  props: {
    previewHeader: {
      type: Boolean,
      default: false,
    },
    previewHandler: {
      type: Object as () => PreviewHandler,
      default: null,
    },
    invitationHeader: {
      type: Boolean,
      default: false,
    },
    quotaLimited: {
      type: Boolean,
      default: true,
    },
    historyId: {
      type: String,
    },
    vistor: {
      type: Boolean,
      default: false,
    },
    inviteTitle: {
      type: Object as () => InviteTitleData,
      required: false,
      default: () => {
        return {
          title: '',
          type: '',
        };
      },
    },
    orgLogoInfo: {
      type: Object as () => OrgLogoInfo,
      require: false,
      default: () => {
        return {
          orgLogo: '',
          orgName: '',
          showOrgNameInUI: undefined,
        };
      },
    },
  },
  components: {
    GeneralHeader,
    PreviewHeader,
    MobileGeneralHeader,
    MobilePreviewHeader,
    InvitationHeader,
    AdminRouterHeader,
    ChevronLeftIcon,
  },
  setup(props) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const adminHideHeaderBar = computed(() => adminRouterName.includes(vm.$route.name as string));

    // header组件可分为主题页header、预览页header、外链邀请页header
    const { previewHeader, invitationHeader } = toRefs(props);
    const isGeneralHeader = !previewHeader.value && !invitationHeader.value;
    const isInvitationHeader = !previewHeader.value && invitationHeader.value;
    const isPreviewHeader = previewHeader.value && !invitationHeader.value;
    const innerPreviewHandler = props.previewHandler;

    return {
      isGeneralHeader,
      isPreviewHeader,
      innerPreviewHandler,
      isInvitationHeader,
      adminHideHeaderBar,
    };
  },
});
